import React from 'react';

import { useAppContext } from 'src/components/app-context';
import { usePriceRowContext } from 'src/areas/product/components/price-list/price-row-context';

import {
  CaptionText,
  FontColor,
  FontEmphasis,
  FontWeight,
} from '@prisjakt/ui/text/variants';
import { ContainerType } from '@prisjakt/ui/lib';
import { getCompiledPriceData } from './price-data';

import {
  PriceDisplay,
  PriceDisplayEnum,
} from 'src/components/price-list/types';
import {
  CampaignMediaColors,
  Maybe,
  OfferPrices,
  Price,
  AlternativePrice,
  Shipping,
} from 'src/types';

import {
  PriceAndShipping,
  StyledBadge,
  StyledPriceLabel,
  StyledSecondaryPrice,
  Wrapper,
} from './styles';

interface IPriceLabel {
  campaignColors?: Maybe<CampaignMediaColors>;
  container?: ContainerType;
  priceDisplay: PriceDisplay;
  offer: Price | AlternativePrice;
  offerPrice?: OfferPrices | null;
  shipping?: Shipping;
}

export const OfferPriceLabel = (props: IPriceLabel) => {
  const {
    campaignColors,
    container,
    priceDisplay,
    offer,
    offerPrice,
    shipping,
  } = props;

  const { t, market } = useAppContext();
  const { isFeatured = false } = usePriceRowContext();

  if (!offer.price) {
    return null;
  }

  const priceData = getCompiledPriceData(
    offer.price,
    offerPrice,
    priceDisplay,
    isFeatured,
    t,
    market
  );

  const getPriceLabel = () => {
    const shippingCost = shipping?.shippingCost || 0;
    const cost = offer.price?.exclShipping || 0;

    if (priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING) {
      return cost + shippingCost;
    }
    return cost;
  };

  return (
    <Wrapper>
      {priceData.label && (
        <>
          {priceData.isMemberPrice ? (
            <StyledBadge color="GREY_INVERTED" text={priceData.label} />
          ) : (
            <CaptionText emphasis={FontEmphasis.MEDIUM}>
              {priceData.label}
            </CaptionText>
          )}
        </>
      )}

      <PriceAndShipping>
        {priceData.secondaryPrice && (
          <StyledSecondaryPrice
            value={priceData.secondaryPrice}
            emphasis={FontEmphasis.LOW}
            weight={FontWeight.NORMAL}
          />
        )}

        {getPriceLabel() && (
          <StyledPriceLabel
            container={container}
            emphasis={isFeatured ? FontEmphasis.HIGH : FontEmphasis.LOW}
            fontColor={campaignColors ? FontColor.NEGATIVE : undefined}
            value={getPriceLabel()}
            weight={FontWeight.HEAVIEST}
          />
        )}
      </PriceAndShipping>
    </Wrapper>
  );
};
